import { Skeleton } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { DispatchDate } from '../../utils/dispatch';

interface Props {
  dispatchDate: DispatchDate;
  variant:
    | 'estimation'
    | 'explainer'
    | 'framedExplainer'
    | 'order'
    | 'schedule';
}

export const ProductDispatchDate: FC<Props> = ({ dispatchDate, variant }) => {
  const { t } = useTranslation('product');

  if (!dispatchDate.weeks) {
    return <Skeleton className="mx-auto h-5 w-30" />;
  }

  const shippingNote = dispatchDate.isPast
    ? t(`dispatchDate.${variant}.weeks`, {
        count: dispatchDate.weeks,
      })
    : t(`dispatchDate.${variant}.range`, {
        range: dispatchDate.range,
      });

  return <p>{shippingNote}</p>;
};
